export interface APIError {
    error: number
    message?: string
}

export function isAPIError(value: unknown): value is APIError {
    if (typeof value !== "object" || value === null) {
        return false
    }

    return (
        "error" in value &&
        typeof (value as any).error === "number" &&
        ((value as any).message === undefined ||
            typeof (value as any).message === "string")
    )
}
